import React, { Component } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Page from 'Shared/components/page/page';
import useBrandContext from 'Contexts/brand-context';
import ErrorMessage from 'Shared/components/error-message';
import { useTranslation } from 'Shared/util/custom-hooks';


/* ToDo: Change from class component when React supports hook for componentDidCatch */
class ErrorBoundaryClass extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidUpdate(prevProps) {
    const { hasError } = this.state;
    const { location } = this.props;

    if (hasError && location.pathname !== prevProps.location.pathname) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ hasError: false });
    }
  }

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  render() {
    const { hasError } = this.state;
    const {
      children,
      history,
      brandData,
      translations: t,
    } = this.props;

    if (!hasError) return children;

    const handleButtonClick = () => history.goBack();
    const { supportEmailAddress } = brandData;

    return (
      <Page
        title={{
          text: t.somethingWentWrong,
          reducedMarginBottom: true,
        }}
      >
        <ErrorMessage
          text={t.format(t.pleaseTryAgainOrContactSupport, { supportEmailAddress })}
          buttonText={t.goBack}
          onButtonClick={handleButtonClick}
        />
      </Page>
    );
  }
}

ErrorBoundaryClass.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  brandData: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  translations: PropTypes.object.isRequired,
};


const ErrorBoundary = ({
  children,
}) => {
  const location = useLocation();
  const history = useHistory();
  const { brandData } = useBrandContext();
  const t = useTranslation(x => x.errors);

  return (
    <ErrorBoundaryClass
      location={location}
      history={history}
      brandData={brandData}
      translations={t}
    >
      {children}
    </ErrorBoundaryClass>
  );
};

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default ErrorBoundary;
